import { WritePermissionKey } from "constants/permissions";
import { useMyPermissions } from "hooks/useMyPermissions";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const useHasWritePermission = (
  permissionKey: WritePermissionKey,
  level: "FULL" | "READ_ONLY" = "FULL"
): boolean => {
  const { isCpa, isForeignCA } = useRoleBasedView();
  const { isSuperAdmin, hasPermission, isLoading } = useMyPermissions();

  if (isCpa || isForeignCA) return true;
  if (isLoading) return true;

  return isSuperAdmin || hasPermission(permissionKey, level);
};
